<template>
  <div id="nav-index" ref="navIndex">
    <div class="menu">
      <div id="logo" class="float-left"><img ref="logo" :src="src0" alt="" style="max-width: 166px" /></div>
      <div id="nav-link" class="float-right d-inline-flex">
        <ul id="nav-all-link" class="other-link yahei">
          <li><router-link to="/">首页</router-link></li>
          <li id="solution" ref="solution" class="pointer toggle-menu">
            <a href="#">解决方案</a>
            <ul id="nav-solution" ref="navSolution">
              <li><router-link to="/solution">道路泊位智能化无人值守解决方案</router-link></li>
              <!-- <li><router-link to="/solution-2">创新篇</router-link></li>
              <li><router-link to="/solution-3">创新篇-大型停车引导</router-link></li> -->
            </ul>
          </li>
          <!-- <li ref="solution">
            <router-link to="/solution">解决方案</router-link>
          </li> -->
          <li id="product" ref="product" class="pointer toggle-menu">
            <a href="#">产品中心</a>
            <ul id="nav-product" ref="navProduct">
              <li><router-link to="/product-1">道路泊位智能翻板</router-link></li>
              <li><router-link to="/product-2">物联网平台</router-link></li>
            </ul>
          </li>
          <li ref="cuscase">
            <router-link to="/custom-case">客户案例</router-link>
          </li>
          <li ref="partner">
            <router-link to="/partner">合作伙伴</router-link>
          </li>
          <li ref="media-news">
            <router-link to="/media-news">品牌动态</router-link>
          </li>
          <li ref="about"><router-link to="/about">关于我们</router-link></li> 
        </ul>
        <div style="padding-left: 80px" class="text-phone text-center c666 fs-24 fs-768-18 d-inline-block">
          <img class="pb-1" src="../assets/home/icon-phone.png" alt=""/>
          <span class="pl-2">0512-67289416</span>
        </div>
      </div>
      <div id="small-nav">
        <div id="nav-img">
          <b-button
            ref="enterNav"
            class="enter-nav" 
            v-b-toggle="'collapse-2'"
            @click="changeCaiDan"
          >
            <img id="menu-img" :class ="i <= 1 && j === 0 ? '' : 'icon_close'" :src=" i <= 1 && j === 0 ? src3 : src4" alt="" />
          </b-button>
        </div>
        <b-collapse id="collapse-2" v-model="showCollapse">
          <b-card>
            <b-card-text>
              <ul>
                <li style="height: 50px"><img :src="src0" alt="" style="max-width: 120px" /></li>
                <li>
                  <router-link to="/">首页<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt=""/></router-link>
                </li>
                <!-- <li>
                  <router-link to="/solution">
                    解决方案<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt="" />
                  </router-link>
                </li> -->
                <li>
                  <b-button id="menu-fa" class="menulist" v-b-toggle="'collapse-solute'" @click="changeJian('so-jiantou-fa')">
                    解决方案<img id="so-jiantou-fa" class="jiantou" src="../assets/phone/dh_qj@3x.png" alt="" @click="changeJian('so-jiantou-fa')" />
                  </b-button>
                  <b-collapse id="collapse-solute" v-model="showSolutionCollapse">
                    <b-card>
                      <b-card-text>
                        <ul>
                          <li><router-link to="/solution">道路泊位智能化无人值守解决方案</router-link></li>
                        </ul>
                      </b-card-text>
                    </b-card>
                  </b-collapse>
                </li>
                <li>
                  <b-button id="menu-cp" class="menulist" v-b-toggle="'collapse-3'" @click="changeJian('so-jiantou-cp')">
                    产品中心<img id="so-jiantou-cp" class="jiantou" src="../assets/phone/dh_qj@3x.png" alt="" @click="changeJian('so-jiantou-cp')" />
                  </b-button>
                  <b-collapse id="collapse-3" v-model="showProductCollapse">
                    <b-card>
                      <b-card-text>
                        <ul>
                          <li><router-link to="/product-1">道路泊位智能翻板</router-link></li>
                          <li><router-link to="/product-2">物联网平台</router-link></li>
                        </ul>
                      </b-card-text>
                    </b-card>
                  </b-collapse>
                </li>
                <li>
                  <router-link to="/custom-case">
                    客户案例<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt=""/>
                  </router-link>
                </li>
                <li>
                  <router-link to="/partner">
                    合作伙伴<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt="" />
                  </router-link>
                </li>
                <li>
                  <router-link to="/media-news">
                    品牌动态<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt=""/>
                  </router-link>
                </li>
                <li>
                  <router-link to="/about">
                    关于我们<img class="jiantou" src="../assets/phone/dh_qj@3x.png" alt=""/>
                  </router-link>
                </li>
              </ul>
            </b-card-text>
          </b-card>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      i: 0,
      j: 0,
      p: 0,
      showCollapse: false,
      showProductCollapse: false,
      showSolutionCollapse: false,
      src0: require("../assets/home/logo_new.png"),
      src3: require("../assets/phone/caidan@3x.png"),
      src4: require("../assets/phone/dh_close@3x.png"),
    };
  },
  mounted() {
    let nproduct = this.$refs.navProduct;
    document.querySelector("#product").onmouseover = document.querySelector("#nav-product").onmouseover = function () {
      nproduct.style.opacity = "1";
    }.bind(this);
    document.querySelector("#product").onmouseout = document.querySelector("#nav-product").onmouseout = function () {
      nproduct.style.opacity = "0";
    }.bind(this);

    let jjfa = this.$refs.navSolution;
    document.querySelector("#solution").onmouseover = document.querySelector("#nav-solution").onmouseover = function () {
      jjfa.style.opacity = "1";
    }.bind(this);
    document.querySelector("#solution").onmouseout = document.querySelector("#nav-solution").onmouseout = function () {
      jjfa.style.opacity = "0";
    }.bind(this);
    
  },
  methods: {
    changeCaiDan: function () {
      if (this.j === 0) {
        this.j = 1;
      } else {
        this.j = 0;
        this.showProductCollapse = false;
        this.showSolutionCollapse = false;
        document.querySelector(".jiantou").style.transform = "rotate(0)";
      }
    },
    changeJian: function (id) {
      let showmenu = id === 'so-jiantou-cp' ? !this.showProductCollapse : !this.showSolutionCollapse;
      document.querySelector("#"+id).style.transform = showmenu ? "rotate(90deg)" : "rotate(0)";
    },
    changeNav: function (type, router) {
      if (type === 1 && router) {
        this.i = 1;
      } else if (type === 0 && router) {
        this.i = 0;
      }
    },
    displayNav(origin, destination, direction) {
      let self = this;
      self.showCollapse = false;
      self.j = 0;
      self.showProductCollapse = false;
      self.showSolutionCollapse = false;
      if (document.body.clientWidth < 970) return;

      setTimeout(function () {
        self.$refs.navIndex.style.opacity = direction === "down" ? 0 : 1;
      }, 0.1);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route: function (to, from) {
      this.showCollapse = false;
      this.j = 0;
      this.showProductCollapse = false;
      this.showSolutionCollapse = false;
      document.querySelectorAll(".jiantou").forEach(function(jt) {
        jt.style.transform = "rotate(0)";
      });
      document.querySelectorAll(".toggle-menu>a").forEach(function(mm) {
        mm.classList.remove('a-selected');
      });
      document.querySelectorAll(".menulist").forEach(function(minm) {
        minm.classList.remove('a-selected');
      });

      // // 默认滚动到顶部
      if (to.name != "product") {
        window.scrollTo(0,0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }

      /// 处理菜单焦点样式
      var parclass = document.body.clientWidth >= 970 ? '#nav-link ' : '#collapse-2 ';

     
      if (to.name == "product-1" || to.name === "product-2") {
        var aparentele = document.body.clientWidth >= 970 ? '#product>a' : '#menu-cp';
        document.querySelector(aparentele).classList.add('a-selected');
        this.changeNav(1, to.name);
      } else if (to.name == 'solution') {
        var aparentele2 = document.body.clientWidth >= 970 ? '#solution>a' : '#menu-fa';
        document.querySelector(aparentele2).classList.add('a-selected');
        this.changeNav(1, to.name);
      } else {
        this.changeNav(0, to.name);
      }

      setTimeout(() => {
        var a = document.querySelector(parclass + 'a[href="#/'+to.name+'"]');
        a && a.classList.add('router-link-exact-active');
      }, 100);
      
    },
    j: function (val) {
      document.querySelector("#menu-img").style.width = val ? "50%" : "100%";
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  transition: all 0.5s;
}
a:hover {
  text-decoration: none;
  color: #275EA3;
  transition: all 0.5s;
}
#nav-index {
  position: fixed;
  top: 0;
  z-index: 1000;
  height: 80px;
  width: 100%;
  padding: 5px auto;
  transition: all 0.5s;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
}
.menu {
  display: inline-block;
  width: 100%;
  padding: 18px 80px 0 80px;
}
.icon_close {
  margin-top: 8px;
}
#nav-link {
  line-height: 42px;
  width: calc(100% - 166px);
  justify-content: right;
}
#nav-link ul {
  list-style: none;
}
#nav-all-link li {
  /* float: left; */
  display: inline-block;
  color: #666;
  padding: 0 20px;
  text-align: center;
  border-bottom: 1px solid white;
  transition: all 0.5s;
  position: relative;
}
#nav-all-link > li {
  border-bottom: 1px solid white;
}
#nav-all-link > li.active {
  border-bottom: 1px solid #275EA3;
}
#nav-all-link li a {
  color: #666;
  font-size: 18px;
}
#nav-all-link li a.router-link-exact-active,
#nav-all-link li:hover > a,
#nav-all-link li.active > a,
#nav-solution li:hover > a,
#nav-product li:hover > a,
#small-nav .collapse-2 li:hover > a, 
.a-selected {
  color: #275EA3 !important;
  font-weight: 500;
}
#nav-all-link a.router-link-exact-active::before {
  position: absolute;
  content: "";
  bottom: -20px;
  left: calc(50% - 35px);
  height: 2px;
  width: 70px;
  background: #275EA3;
}
#nav-solution a.router-link-exact-active::before,
#nav-product a.router-link-exact-active::before {
  color: transparent !important;
  background: transparent;
}
#nav-solution, #nav-product {
  opacity: 0;
  width: auto;
  height: auto;
  transition: all 0.5s;
  position: absolute;
  top: 50px;
  left: -100px;
  padding: 0;
  margin: 0;
  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.1);
}
#nav-product {
  left: -20px;
}
#nav-solution li, #nav-product li {
  color: white;
  width: auto;
  min-width: 100%;
  white-space: nowrap;
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid white;
  transition: all 0.5s;
  background: white;
}
#nav-solution li:hover, #nav-product li:hover {
  background: #ecf0fd !important;
}
#small-nav {
  display: none;
}
.active {
  border-bottom: 1px solid #275EA3 !important;
  color: #275EA3 !important;
}
@media only screen and (max-width: 1500px) {
  .menu {
    padding: 18px 40px 0 40px;
  }
  .text-phone {
    padding-left: 20px !important;
    font-size: 16px;
  }
  .text-phone img {
    width: 20px;
  }
  #nav-all-link li {
    padding: 0 15px;
  }
  #nav-all-link li a {
    font-size: 16px;
  }
}
@media only screen and (max-width: 1100px) {
  .text-phone {
    display: none !important;
  }
}

@media only screen and (max-width: 970px) {
  .menu {
    padding: 18px 10px 0 20px;
  }
  #nav-link {
    display: none !important;
  }
  #small-nav {
    display: block;
  }
  #nav-img {
    float: right;
    margin-right: 10px;
    position: relative;
    z-index: 10000;
  }
  #nav-img button {
    width: 32px;
    position: absolute;
    top: 6px;
    right: 5px;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    box-shadow: none;
  }
  #nav-img button img {
    width: 100%;
  }

  #small-nav-link {
    opacity: 0;
    text-align: center;
    position: absolute;
    left: 50%;
    top: -200%;
    transform: translate(-50%, -50%);
    list-style: none;
    margin: 0;
    padding: 0;
    transition: all 0.5s;
  }
  #small-nav-link li {
    margin: 10px auto;
    line-height: 20px;
  }
  .show-nav {
    opacity: 1 !important;
    top: 250% !important;
    transition: all 0.5s;
  }
  .enter-nav {
    opacity: 1;
    position: relative;
    z-index: 1001;
    transition: all 0.5s;
  }
  .close-nav {
    opacity: 0;
    position: relative;
    z-index: 1000;
    transition: all 0.5s;
  }
  #collapse-2 {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9999;
  }
  #collapse-2 > .card {
    border: none;
    border-radius: 0;
    height: 100vh;
    width: 250px;
  }
  #collapse-2 ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  #collapse-2 ul li {
    border-bottom: 1px solid #e6e6e6;
    position: relative;
  }
  #collapse-2 ul li a {
    font-size: 15px;
    color: #000000;
    line-height: 50px;
  }
  #collapse-2 ul li a.router-link-exact-active {
    color: rgb(90, 130, 240);
  }
  .jiantou {
    position: absolute;
    top: 20px;
    right: 25px;
    width: 6px;
    transition: all 0.5s;
  }
  .menulist {
    background: white !important;
    border: none !important;
    padding: 0;
    margin: 0;
    font-size: 15px;
    color: #000000;
    line-height: 50px;
    box-shadow: none !important;
    width: 100%;
    text-align: left;
    box-shadow: none !important;
    outline: none !important;
    -webkit-tap-highlight-color: transparent;
  }
  #collapse-3 .card, #collapse-solute .card {
    border: none;
    border-radius: 0;
  }
  #collapse-3 ul li, #collapse-solute ul li {
    border-bottom: none;
  }
  #collapse-3 ul li a, #collapse-solute ul li a {
    font-size: 13px;
    color: #4a4a4a;
  }
  #collapse-3 .card-body, #collapse-solute .card-body {
    padding: 0;
  }
}

@media only screen and (max-width: 450px) {
  #nav-index {
    height: 60px;
    padding: 5px auto;
  }
  .menu {
    padding-top: 12px;
  }
  #logo > img {
    height: 34px;
  }
  #nav-img button {
    width: 28px;
    line-height:28px;
  }
}
</style>